// pages/Dashboard.jsx
import JustLaunchedBooks from "../../components/home/JustLaunchedBooks";
import HomeLayout from "../../components/home/HomeLayout";

export default function Dashboard() {
  return (
    <HomeLayout>
      <JustLaunchedBooks />
    </HomeLayout>
  );
}
